import { A365BackendModel as Model } from '../a365.backendmodel';
import { Metamodel } from '../base/model';
import { AdapterRegistry } from './adapter-registry';
import { KqlScriptMetadata, KqlScript, KqlScriptContent, KqlScriptConnectionKey } from '../kqlscript/kqlscript';
import { NamedAdapter } from './named.adapter';
import { ModelConstants } from '../model-constants';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(KqlScript),
    adapts: {
        name: '*',
        properties: {
            description: '*',
            content: '*',
            folder: '*'
        }
    }
})
export class KqlScriptAdapter extends NamedAdapter<KqlScript, Model.KqlScriptResource> {
    protected _toResource(kqlscript: KqlScript): Model.KqlScriptResource {
        const kqlScriptResource = super._toResource(kqlscript) as Model.KqlScriptResource;
        this.properties(kqlScriptResource).content = {};
        kqlScriptResource.properties.type = kqlscript.type;

        if (kqlscript.content) {
            kqlScriptResource.properties.content.query = kqlscript.content.query;
            if (kqlscript.content.metadata) {
                kqlScriptResource.properties.content.metadata = {
                    language: kqlscript.content.metadata.language
                };
            }

            if (kqlscript.content.currentConnection) {
                kqlScriptResource.properties.content.currentConnection = {
                    poolName: kqlscript.content.currentConnection.poolName,
                    databaseName: kqlscript.content.currentConnection.databaseName
                };
            }
        }

        return kqlScriptResource;
    }

    protected _toModel(kqlScriptResource: Model.KqlScriptResource, kqlscript?: KqlScript): KqlScript {
        if (!kqlscript) {
            kqlscript = KqlScript.MODEL.create<KqlScript>();
        }
        super._toModel(kqlScriptResource, kqlscript);
        kqlscript.resourceType = ModelConstants.kqlScript + 's';

        if (kqlScriptResource.properties) {
            kqlscript.type = kqlScriptResource.properties.type;

            if (kqlScriptResource.properties.content) {
                if (!kqlscript.content) {
                    kqlscript.content = new KqlScriptContent();
                }

                kqlscript.content.query = kqlScriptResource.properties.content.query;

                if (kqlScriptResource.properties.content.metadata) {
                    if (!kqlscript.content.metadata) {
                        kqlscript.content.metadata = new KqlScriptMetadata();
                    }
                    kqlscript.content.metadata.language = kqlScriptResource.properties.content.metadata.language;
                }

                if (kqlScriptResource.properties.content.currentConnection) {
                    kqlscript.content.currentConnection = new KqlScriptConnectionKey();
                    kqlscript.content.currentConnection.poolName = kqlScriptResource.properties.content.currentConnection.poolName;
                    kqlscript.content.currentConnection.databaseName = kqlScriptResource.properties.content.currentConnection.databaseName;
                }
            }
        }

        return kqlscript;
    }
}
